
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/studio/features",
      function () {
        return require("private-next-pages/products/studio/features.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/studio/features"])
      });
    }
  